import useResource from 'app/hooks/useResource';

import {
  getContentProviders,
  setContentProviderParams
} from 'app/actions/contentProviders';

import {
  createContentProvider,
  updateContentProvider,
  destroyContentProvider
} from 'app/services/contentProviders';

import {
  contentProviders as resource
} from 'app/resources';

const useContentProviders = () => {
  return useResource({
    resource,
    getResource: getContentProviders,
    createResource: createContentProvider,
    updateResource: updateContentProvider,
    setResourceParams: setContentProviderParams,
    destroyResource: destroyContentProvider
  });
}

export default useContentProviders;
